import { API_CONFIG, getApiUrl } from "@/config/apiConfig";
import { getAuthHeaders } from "./authApi";
import { requestPermission } from "@/utils/notifications/requestPermission";

export const saveDeviceToken = async (token: string) => {
  const url = API_CONFIG.endpoints.notifications.settoken;

  const response = await fetch(getApiUrl(url), {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ token }), // ✅ FIXED
  });

  const data = await response.json();

  if (!response.ok) {
    throw {
      status: response.status,
      message: data.message || "Failed to save device token",
    };
  }

  return data;
};

export const setupNotifications = async () => {
  try {
    const token = await requestPermission();

    if (token) {
      // console.log("<<<<Setup Notification");
      await saveDeviceToken(token);
      localStorage.setItem("device_token", token);
    }
  } catch (err) {
    console.error("Notification setup failed:", err);
  }
};
